import {
    REQUEST_WHOLESALE,
    FETCH_WHOLESALE_SUCCESS,
    FETCH_WHOLESALE_FAILURE,
    SELECT_WHOLESALE,
    RESET_CURRENT_WHOLESALE,
    REQUEST_WHOLESALE_DETAIL,
    FETCH_WHOLESALE_DETAIL_SUCCESS,
    FETCH_WHOLESALE_DETAIL_FAILURE,
    REQUEST_CREATING_WHOLESALE,
    CREATE_WHOLESALE_SUCCESS,
    CREATE_WHOLESALE_FAILURE,
    REQUEST_EDITING_WHOLESALE,
    EDIT_WHOLESALE_SUCCESS,
    EDIT_WHOLESALE_FAILURE
} from '../actions/type';

const INITIAL_STATE = {
    all: [],
    currentWholesale: null,
    currentWholesaleDetail: null,
    isLoading: true,
    error: null,
    detailIsLoading: false,
    detailError: null,
    wholesaleIsCreating: false,
    wholesaleCreateError: null,
    wholesaleCreated: false,
    wholesaleIsEditing: false,
    wholesaleEditError: null,
    wholesaleEdited: false,
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        // Product action handlers
        case REQUEST_WHOLESALE:
            return { ...state, error: null, isLoading: true };
        case FETCH_WHOLESALE_SUCCESS:
            return { ...state, all: action.payload.data, error: null, isLoading: false };
        case FETCH_WHOLESALE_FAILURE:
            const error = action.payload || { message: action.payload.message };
            return { ...state, all: [], error: error, isLoading: false };
        case SELECT_WHOLESALE:
            return {...state, currentWholesale: action.payload };
        case RESET_CURRENT_WHOLESALE:
            return { ...state, currentWholesale: null, currentWholesaleDetail: null };
        case REQUEST_WHOLESALE_DETAIL:
            return { ...state, detailError: null, detailIsLoading: true };
        case FETCH_WHOLESALE_DETAIL_SUCCESS:// return list of posts and make loading = false
            return { ...state, currentWholesaleDetail: action.payload, detailError: null, detailIsLoading: false };
        case FETCH_WHOLESALE_DETAIL_FAILURE:// return error and make loading = false
            const detailError = action.payload || { message: action.payload.message };//2nd one is network or server down errors
            return { ...state, all: [], detailError: detailError, detailIsLoading: false };
        case REQUEST_CREATING_WHOLESALE:
            return { ...state, wholesaleIsCreating: true, wholesaleCreateError: null, wholesaleCreated: false };
        case CREATE_WHOLESALE_SUCCESS:
            return { ...state, wholesaleIsCreating: false, wholesaleCreateError: null, wholesaleCreated: true };
        case CREATE_WHOLESALE_FAILURE:
            const wholesaleCreateError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, wholesaleIsCreating: false, wholesaleCreateError: wholesaleCreateError, wholesaleCreated: false };
        case REQUEST_EDITING_WHOLESALE:
            return { ...state, wholesaleIsEditing: true, wholesaleEditError: null, wholesaleEdited: false };
        case EDIT_WHOLESALE_SUCCESS:
            return { ...state, wholesaleIsEditing: false, wholesaleEditError: null, wholesaleEdited: true };
        case EDIT_WHOLESALE_FAILURE:
            const wholesaleEditError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, wholesaleIsEditing: false, wholesaleEditError: wholesaleEditError, wholesaleEdited: false };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./master/jsx/reducers/wholesale_reducer.jsx